
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // How long data stays fresh
      staleTime: 5 * 60 * 1000, // 5 minutes
      
      // How long data is cached before garbage collection
      gcTime: 10 * 60 * 1000, // 10 minutes
      
      // Retry failed queries up to 3 times
      retry: 3,
      
      // Don't refetch on window focus
      refetchOnWindowFocus: false,
      
      // Refetch when network reconnects
      refetchOnReconnect: true,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
})
